import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import ScrollIndicator from "../Home/ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";

import PagePublicContent from "./components/PagePublicContent";
import PagePublicNotFound from "./components/PagePublicNotFound";
import PagePublicSkeleton from "./components/PagePublicSkeleton";

import { usePublicPage } from "./hooks/usePublicPage";

export default function PagePublic() {
  useScrollToTop();

  const {
    loading,
    error,
    page,
    heroImage,
    isUnavailable,
    refresh,
  } = usePublicPage();

  if (loading) {
    return (
      <>
        <PageHero
          title="Chargement"
          imageUrl="/img/hero-default.jpg"
          crumbs={[
            { label: "Accueil", href: "/" },
            { label: "Chargement" },
          ]}
        />

        <ScrollIndicator />

        <PagePublicSkeleton />
      </>
    );
  }

  if (isUnavailable) {
    return (
      <>
        <PageHero
          title="Page introuvable"
          imageUrl="/img/hero-default.jpg"
          crumbs={[
            { label: "Accueil", href: "/" },
            { label: "Page introuvable" },
          ]}
        />

        <ScrollIndicator />

        <PagePublicNotFound error={error} onRefresh={refresh} />
      </>
    );
  }

  return (
    <>
      <PageHero
        title={page.title}
        imageUrl={heroImage}
        crumbs={[
          { label: "Accueil", href: "/" },
          { label: page.title },
        ]}
      />

      <ScrollIndicator />

      <main>
        <div className="mx-auto max-w-[1180px] px-4 pt-6 sm:px-6 md:pt-8">
          <PageSectionHeader
            eyebrow="Information"
            title={page.title}
            description={page.subtitle}
          />
        </div>

        <PagePublicContent page={page} />
      </main>
    </>
  );
}